import api from "@services/apiList";
import { ResponseType } from "../../Types/ServicesType/servicesType";
import {  RemitanceActivityType, SearchRemittanceParams, SearchResponseType } from "./types";
import instance from "@services/services";

const { insuranceApi, clinicId } = api;
const errorResponse: Omit<ResponseType<any>, "response"> = {
  responseIndicator: "fail",
  responseMessage: "Something went wrong",
  statusCode: "500",
};

export const downloadRemitance = async (): Promise<ResponseType<SearchResponseType | null>> => {
  const body = {
    clinicId,
  };
  const result = await instance.post(
    `${insuranceApi.downloadRemitance}`,
    body
  );
  return result.data;
};

export const searchRemittanceWithDate = async (
  params: Omit<SearchRemittanceParams, "clinicId">
): Promise<ResponseType<SearchResponseType | null>> => {
  try {
    const body: SearchRemittanceParams = {
      clinicId,
      ...params,
    };
    const result = await instance.post(
      `${insuranceApi.searchRemittanceWithDate}`,
      body
    );
    return result.data;
  } catch (error) {
    return {
      ...errorResponse,
      response: null,
    };
  }
};

export const getRemittanceActivityDetails = async (id:string): Promise<ResponseType<RemitanceActivityType[] | null>> => {
  try {
    const result = await instance.get(
      `${insuranceApi.getRemittanceActivity}${clinicId}?id=${id}`,
    );
    return result.data;
  } catch (error) {
    return {
      ...errorResponse,
      response: [],
    };
  }
};


